<template>
  <div class="box1">
    <img src="../../../assets/coursePage/trainer/08/01.png"/>
   
   
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
 padding-bottom: 40px;
  width: 100%;
  min-height: 530px;
  background: url("../../../assets/coursePage/trainer/08/bg.png") center top no-repeat;
  background-size: contain;
 

  box-sizing: border-box;
  img{
   
    width: 100%;
  }
  >img{
     margin-top: 150px;
  }
  .img2{
    padding: 0 32px;
  }
}
</style>
